import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="content-request"
export default class extends Controller {
  static targets = ["input", "publishDateField", "dueDateField"]
  static values = {
    contentType: String,
    isIdpManaged: Boolean
  }

  connect() {
    const selectedType = this.contentTypeValue || "content_group"

    this.toggle(selectedType)
  }

  toggleInput(event) {
    const selectedType = event.target.value

    this.toggle(selectedType)
  }

  toggle(contentType) {
    if (this.isIdpManagedValue) return

    this.inputTargets.forEach(input => {
      if (contentType != "faq") {
        input.classList.remove("hidden")
      } else {
        input.classList.add("hidden")
      }
    })
  }

  publishDateChanged() {
    if (!this.isIdpManagedValue) return
    if (!this.hasPublishDateFieldTarget || !this.hasDueDateFieldTarget) return
    if (this.dueDateFieldTarget.value) return

    const publishDate = this.parseDate(this.publishDateFieldTarget.value)
    if (!publishDate) return

    const dueDate = new Date(publishDate.getTime())
    dueDate.setDate(dueDate.getDate() + 7)

    this.dueDateFieldTarget.picker.selectDate(dueDate)
  }

  parseDate(value) {
    const match = value && value.match(/^(\d{2})\/(\d{2})\/(\d{4})$/)
    if (!match) return null

    const [ , day, month, year ] = match
    return new Date(Number(year), Number(month) - 1, Number(day))
  }
}
